import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CustomButton from "../../../components/CustomButton";

const PromptLocalWithholdings = ({ show, onConfirm, onCancel }: any) => {
  return (
    <Modal
      disableAutoFocus
      open={show}
      onClose={() => onCancel()}
      aria-labelledby="confirm-w2-modal"
      className={'modal-container'}
    >
      <div className={'modal-paper'}>
        <Box component="h3" m={1} className={'modal-title'}>
          Missing local withholdings
        </Box>
        <p className={'modal-sub-title'}>Please double-check your W-2 form to confirm that box 18, 19, and 20 are not blank.</p>
        <Box className={'modal-button-container'}
        >
          <CustomButton
            variant="outlined"
            disableElevation={false}
            label={"Back"}
            onClick={() => onCancel()}
            buttonSize={'modal-button-left'}
          />
          <CustomButton
            variant="contained"
            disableElevation={true}
            label={"Accept"}
            onClick={() => onConfirm()}
          />
        </Box>
      </div>
    </Modal>
  );
};

export default PromptLocalWithholdings;
